import { render } from "./special-info-box.vue?vue&type=template&id=1693be08&scoped=true"
import script from "./special-info-box.vue?vue&type=script&lang=js"
export * from "./special-info-box.vue?vue&type=script&lang=js"

import "./special-info-box.vue?vue&type=style&index=0&id=1693be08&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1693be08"]])

export default __exports__